import React from 'react';

export const FullscreenModel = ({ isModalOpen, setIsModalOpen, modalImage, setModalImage }) => {
    const closeImageModal = () => {
        setIsModalOpen(false);
        setModalImage(null);
    };

    return (
        isModalOpen && (
            <div
                className="d-flex gap-3 flex-column"
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.8)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1000, // Modal z-index
                }}
                onClick={closeImageModal}
            >
                <img
                    src={modalImage}
                    style={{
                        maxWidth: "70%",
                        maxHeight: "70%",
                        minWidth: "20%",
                        boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.7)",
                        borderRadius: "8px",
                        zIndex: 1,  // Ensures the image is below the close button
                    }}
                    alt="Full View"
                    onClick={(e) => e.stopPropagation()} // Prevent closing when clicking the image
                    onError={(e)=>{
                        e.target.onerror = null;
                        e.target.src = process.env.PUBLIC_URL + "/assets/images/no-image-vector.svg";
                        e.target.style.backgroundColor = "white";
                        
                    }}
                />
                <button
                    style={{
                        position: "absolute",
                        top: "80px",  // Adjust top to make sure it is not behind the header
                        right: "30px",  // Adjust right to align it properly
                        background: "transparent",
                        border: "none",
                        color: "white",
                        fontSize: "30px", // Increased size for better visibility
                        cursor: "pointer",
                        zIndex: 2000, // Ensure the close button is above the modal and all other content
                    }}
                    onClick={closeImageModal}
                >
                    &times;
                </button>
            </div>
        )
    );
};
